import { Component, EventEmitter, Output, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { FastAPIService } from 'src/app/service/fast-api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-wordsegment',
  templateUrl: './wordsegment.component.html',
  styleUrls: ['./wordsegment.component.scss']
})
export class WordsegmentComponent implements OnInit, OnChanges {
  @Output() isLoadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() segmentedWordsChange = new EventEmitter<string[]>();
  @Input() searchQuery: string = '';

  question: string = '';
  searchQuestion: string = '';
  nlpResult: any;
  nerResult: any;
  nerKey: any;
  nerValue: any;
  synonym: any;
  isLoading: boolean = true;
  combinedWords: string[] = [];

  constructor(private service: FastAPIService, private route: ActivatedRoute) { }

  ngOnInit() {
    //console.log("WordsegmentComponent initialized with searchQuery:", this.searchQuery);
    this.route.queryParams.subscribe(params => {
      if (params['question']) {
        this.searchQuestion = params['question'];
        this.getNlp(this.searchQuestion);
      } else {
        this.searchQuestion = this.service.currentQuestion;
        if (this.searchQuestion) {
          this.getNlp(this.searchQuestion);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchQuery'] && this.searchQuery) {
      this.searchQuestion = this.searchQuery;
      //console.log("Search Query in WordsegmentComponent:", this.searchQuery); 
      this.getNlp(this.searchQuery);
    }
  }

  pressEnter(event: any, question: string) {
    if (!question || question.trim() === '') {
      event.target.blur();
      return;
    }
    this.getNlp(question);
  }

  getNlp(question: string) {
    this.searchQuery = question;
    this.isLoading = true;
    this.isLoadingChange.emit(true);
    this.nlpResult = '';
    this.nerKey = '';
    this.nerValue = '';
  
    this.service.getNLPshowcase(question).subscribe(
      (response) => {
        this.nlpResult = response.response.data;
        this.nerResult = response.response.data.NERTag;
        this.synonym = response.response.data.Synonym;
  
        if (this.nerResult) {
          this.nerKey = Object.keys(this.nerResult);
          this.nerValue = Object.values(this.nerResult);
        }
  
        this.combineWords(); 
        this.segmentedWordsChange.emit(this.combinedWords); 
      },
      (error) => {
        console.error("Error fetching NLP data:", error);
        this.isLoadingChange.emit(false);
        this.isLoading = false;
      },
      () => {
        this.isLoadingChange.emit(false);
        this.isLoading = false;
      }
    );
  }

  combineWords() {
    let wordSet = new Set<string>();
  
    if (this.nlpResult.WordSegment) {
      this.nlpResult.WordSegment.forEach((word: string) => wordSet.add(word.trim().toLowerCase()));
    }
  
    if (this.nlpResult.POSTag) {
      ['Noun', 'Verb'].forEach(pos => {
        if (this.nlpResult.POSTag[pos]) {
          this.nlpResult.POSTag[pos].forEach((word: string) => wordSet.add(word.trim().toLowerCase()));
        }
      });
    }
  
    if (this.nerResult) {
      Object.values(this.nerResult).forEach((nerItem: any) => {
        nerItem.forEach((word: string) => wordSet.add(word.trim().toLowerCase()));
      });
    }
  
    this.combinedWords = Array.from(wordSet);
    this.segmentedWordsChange.emit(this.combinedWords);
  }
}
